import { SettingsSectionLabel } from "@/components/settings/SettingsSectionLabel";
import { useLanguage } from "@/lib/i18n/LanguageContext";
import type { BilledBuilding, BillingOverview } from "../types";
import { BillingTable } from "./BillingTable";
import { RestrictedActionButton } from "./RestrictedActionButton";

interface CurrentPeriodBuildingsProps {
  overview: BillingOverview;
  addDisabledReason?: string;
  removeDisabledReason?: string;
  chooseForRemoval: (building: BilledBuilding) => void;
  openAdd: () => void;
}

export function CurrentPeriodBuildings({
  addDisabledReason,
  openAdd,
  ...tableProps
}: CurrentPeriodBuildingsProps) {
  const { t } = useLanguage();
  const copy = t.billing.table;
  // An organisation with billing details and no buildings gets the designed
  // empty state rather than an empty table with a €0.00 footer.
  const isEmpty = tableProps.overview.buildings.length === 0;

  return (
    <section className="space-y-4 py-10 first:pt-0">
      <div className="flex items-center justify-between gap-4">
        <SettingsSectionLabel>{copy.sectionTitle}</SettingsSectionLabel>
        <RestrictedActionButton
          variant="outline"
          className="border-primary"
          disabledReason={addDisabledReason}
          onClick={openAdd}
          {...pageInfoTarget("billing.addBuilding")}
        >
          <Plus aria-hidden="true" className="h-4 w-4 text-primary" />
          {copy.add}
        </RestrictedActionButton>
      </div>
      {isEmpty ? (
        <div className="flex min-h-48 flex-col items-center justify-center rounded-md border border-dashed border-border text-center">
          <h3 className="font-semibold">{copy.emptyTitle}</h3>
          <p className="mt-1 max-w-md px-6 text-sm text-muted-foreground">{copy.emptyBody}</p>
        </div>
      ) : (
        <BillingTable {...tableProps} />
      )}
    </section>
  );
}
import { Plus } from "lucide-react";
import { pageInfoTarget } from "@/components/page-info/pageInfoTarget";
